import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../hoc";
// import the corresponding css file
import "./Results.css";
// import the separated file related to the component
import EC20Results from "./EC20Results/EC20Results";
import SpaCResults from "./SpaCResults/SpaCResults";
import HGTResults from "./HorizontalGeneTransfer/HGTResults";
// import the image you want for the top of the page
import { BacteriaSlider } from "../utils";
import { RingLoader } from "react-spinners";
import { scrollToId } from "../../utils/scrollToId";
const Results = ({ setDisplayNavBar }) => {
  const [loading, setLoading] = useState(true);
  // when the page is loaded from the navbar, it sets the position of the user at the top of the page
  useEffect(() => {
    let url = window.location.href
    let lastLetter = url.charAt(url.length -1)
    let secondLastLetter = url.charAt(url.length -2)

    if(secondLastLetter === "_"){
      if(lastLetter === "e"){
        setPage(1)
      } else if(lastLetter === "s"){
        setPage(2)
      } else if(lastLetter === "h"){
        setPage(3)
      }
    }

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    setDisplayNavBar(!loading);
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar]);

  const [page, setPage] = useState(1);
  const sliderHandle = (newValue) => {
    setPage(newValue);
  };

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div className="relative">
       {loading ? ( // Conditionally render spinner or content based on loading state
        <div className="spinner-container fixed h-screen w-screen bg-white z-10">
          <RingLoader color="#BA55D3" loading={loading} />{" "}
          {/* Use BarLoader from react-spinners */}
          <script>{document.body.style.overflow = 'hidden'}</script>
        </div>
      ) : <script>{document.body.style.overflow = 'auto'}</script> }
      <>
       
        {/* Set the size and crop the image on top of the page */}
        <div className="top-page">
          <h1>Results</h1>
        </div>
        {/* divide the section in columns */}
        {/* main content which is a separated file you call and it is displayed on the right of the section above */}
        <BacteriaSlider value={page} onChange={sliderHandle} />
        <main style={{ marginRight: "50px" }}>
          {page === 1 ? (
            <div className="fade-in mt-[2rem]">
              <EC20Results />
            </div>
          ) : page === 2 ? (
            <div className="fade-in1 mt-[2rem]">
              <SpaCResults />
            </div>
          ) : page === 3 ? (
            <div className="fade-in2 mt-[2rem]">
              <HGTResults />
            </div>
          ):<></>}
        </main>
       </>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(Results, "results");
